/**
 * Live status/last_seen of a device (the tablet's 5-minute heartbeat), so the
 * current-action panel can say when the tablet seems offline (BA-58)
 */

import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';

export function useDeviceLastSeen(deviceId: string): number | null {
  const [lastSeen, setLastSeen] = useState<number | null>(null);

  useEffect(() => {
    setLastSeen(null);
    if (!deviceId) {
      return;
    }
    const lastSeenRef = ref(database, `/devices/${deviceId}/status/last_seen`);
    const unsubscribe = onValue(
      lastSeenRef,
      (snapshot) => {
        const value = snapshot.val();
        setLastSeen(typeof value === 'number' ? value : null);
      },
      (err) => console.error('Error listening to last_seen:', err)
    );
    return () => unsubscribe();
  }, [deviceId]);

  return lastSeen;
}
